module.exports = __webpack_public_path__ + "img/blog-2.6b691607.webp";